The date & time the `CandidateProfile` was purchased.

This field has weak ordering guarantees, so it should not be used as a pagination argument.
